import { and, isDateControl, JsonFormsRendererRegistryEntry, rankWith, uiTypeIs, optionIs } from '@jsonforms/core';
import controlRenderer from './DateControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(20, and(uiTypeIs('CustomDateControl'), optionIs('version', 'v2'))),
};
